import { observer } from 'mobx-react';
import { TagIcon } from "../VaultFilters/components/TagsDropdown.styles";
import { SmartTagIcon } from "../VaultMetadataPanel/MetadataLabelsSection/TagsTagCategory/SmartTagIcon";
import { VaultListTagWrapper, VaultListTagWrapperText } from "./VaultListTags.styles";
import { PREDEFINED_TAG_NAMES } from '../../data/vault-store';

export const VaultDocumentTypeTags = observer(({ tags, minimized }) => {
    const isMinimized = (minimized && (tags.length > 1));
    const displayTags = isMinimized ? tags.slice(0, 1) : tags;

    return (
        displayTags.map((tagObj, index) => {
            const tagName = typeof tagObj === 'string'
                ? tagObj
                : (tagObj.tag || tagObj.name || tagObj.label || tagObj.id || '');
            const tagLabel = typeof tagObj === 'string'
                ? tagObj
                : (PREDEFINED_TAG_NAMES[tagObj.label] || tagObj.label || tagObj.name || tagObj.tag || tagObj.id || '');

            return (
                <VaultListTagWrapper key={index}>
                    <TagIcon>
                        <SmartTagIcon tagName={tagName} size={18} />
                    </TagIcon>
                    <VaultListTagWrapperText>{isMinimized ? `${tags.length} tags` : tagLabel}</VaultListTagWrapperText>
                </VaultListTagWrapper>
            );
        })
    );
});